import { render, staticRenderFns } from "./SendConfirmMailMobile.vue?vue&type=template&id=215ceee0&scoped=true&"
import script from "./SendConfirmMailMobile.vue?vue&type=script&lang=js&"
export * from "./SendConfirmMailMobile.vue?vue&type=script&lang=js&"
import style0 from "./SendConfirmMailMobile.vue?vue&type=style&index=0&id=215ceee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ceee0",
  null
  
)

export default component.exports